import React from 'react';
import { useNavigate } from 'react-router-dom';
import Breadcrumb, { BreadcrumbGroup } from '@amzn/meridian/breadcrumb';

export interface BreadcrumbLink {
  label: string;
  url: string;
}

interface BreadcrumbsProps {
  breadcrumbList: BreadcrumbLink[];
}

const Breadcrumbs = ({ breadcrumbList }: BreadcrumbsProps) => {
  const navigate = useNavigate();

  return (
    <BreadcrumbGroup>
      {breadcrumbList.map((item, index) => (
        <Breadcrumb key={index} href={item.url} onClick={navigate}>
          {item.label}
        </Breadcrumb>
      ))}
    </BreadcrumbGroup>
  );
};

export default Breadcrumbs;
